import { Divider, Flex, Text } from "@chakra-ui/react";
import { useColor } from "@styles/useColor";
import { type Transaction, TransactionDirections, normalizeTimestamp } from "@umami/chains";

import { AddressPill } from "./AddressPill";

type NormalTransactionDetailsProps = {
  operation: Transaction;
  address: string;
  txDirection: typeof TransactionDirections.RECEIVE | typeof TransactionDirections.SEND;
};

const isMobile = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.innerWidth <= 768;
};

export const NormalTransactionDetails = ({
  operation,
  address,
  txDirection,
}: NormalTransactionDetailsProps) => {
  const color = useColor();

  return (
    <>
      <Text color={color("600")} fontSize="sm">
        {normalizeTimestamp(operation.timestamp, { isShort: isMobile() })}
      </Text>
      <Divider
        display={{ base: "none", md: "block" }}
        height="16px"
        borderColor={color("300")}
        orientation="vertical"
      />
      <Flex alignItems="center" gap="4px">
        <Text color={color("600")} fontSize="sm">
          {txDirection === TransactionDirections.SEND ? "To:" : "From:"}
        </Text>{" "}
        <AddressPill address={address} explorerUrl={operation.explorerUrl} />
      </Flex>
    </>
  );
};
